// extracted by mini-css-extract-plugin
export default {"row":"Rows-module__row--_8DdE","box":"Rows-module__box--SWcFu"};